import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import FormTextInput from "Components/FormInput";
import "./CreateAccount.css";
import {
  dismissPublicModal,
  setPublicModal,
} from "Store/features/public/publicStateSlice";
import { MODALS } from "../..";

import puzzleGenie from "Assets/PuzzleGenieLoFi.png";

const CREATE_ACCONT_FORM_LABELS = {
  USERNAME: "Username",
  EMAIL: "Email",
  PASSWORD: "Password",
};

const CreateAccount = (props) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const handleEmailChange = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );
  const handleUsernameChange = useCallback(
    (e) => {
      setUsername(e.target.value);
    },
    [setUsername]
  );
  const handlePasswordChange = useCallback(
    (e) => {
      setPassword(e.target.value);
    },
    [setPassword]
  );

  const handlClickLoginToAccount = useCallback(
    (e) => {
      dispatch(dismissPublicModal());
      dispatch(setPublicModal(MODALS.PUZZLE_GENIE_LOGIN));
    },
    [dispatch]
  );

  return (
    <div className="create-account-modal">
      <div
        className="create-account-form-container"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={puzzleGenie} />
        <div className="create-account-form-title">
          Create a Postcast Account!
        </div>
        <div className="create-account-form-description">
          Set a username!
          <br />
          Compete for top scores!
        </div>
        <div className="create-account-form-input-container">
          <FormTextInput
            inputLabel={CREATE_ACCONT_FORM_LABELS.USERNAME}
            onChange={handleUsernameChange}
            value={username}
          />
          <FormTextInput
            inputLabel={CREATE_ACCONT_FORM_LABELS.EMAIL}
            onChange={handleEmailChange}
            value={email}
            inputType={CREATE_ACCONT_FORM_LABELS.EMAIL}
          />
          <FormTextInput
            inputLabel={CREATE_ACCONT_FORM_LABELS.PASSWORD}
            onChange={handlePasswordChange}
            value={password}
            inputType={CREATE_ACCONT_FORM_LABELS.PASSWORD}
          />
        </div>
        <div className="shameless-newsie-sub-checkbox">
          <input type="checkbox" />
          Subscribe to <a href="https://www.newsie.fyi">newsie.fyi</a> -- a fun
          daily news quiz
        </div>
        <div className="create-account-modal-claim-username-button">
          Claim Username!
        </div>
        if you already have an account:
        <div
          className="create-account-login-button"
          onClick={handlClickLoginToAccount}
        >
          Login
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
